// Libs
import propTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";

// Styles
import s from "./index.module.scss";

// Initial Data
import DashboardMenu from "data/dashboard-layout";

const { Sider } = Layout;

function DashboardLayoutSider(props) {
  const { collapsed, setCollapsed } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split("/")?.[3];

  //#region  Handle Menu Highlight
  const [currentUrl, setCurrentUrl] = useState(false);
  const handleSelectMenu = ({ key }) => {
    setCurrentUrl(key);
  };
  useEffect(() => {
    setCurrentUrl(currentPath || "dashboard");
  }, [currentPath]);
  //#endregion

  //#region  Handle Dashboard Menu
  const dashboardMenu = DashboardMenu();
  //#endregion

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        className={s.sider}
      >
        <div
          className={s.logoContainer}
          onClick={() => {
            navigate("/");
          }}
        >
          <img
            src={collapsed ? "/logo-icon.png" : "/logo.png"}
            className={s.logo}
            alt="logo"
            data-test="dashboard-logo"
          />
        </div>
        <Menu
          mode="inline"
          className={s.menuContainer}
          selectedKeys={currentUrl}
          onSelect={handleSelectMenu}
        >
          {dashboardMenu.map((item) => {
            return (
              <>
                <Menu.Item icon={item.icon} key={item.key}>
                  <div data-testId={item.dataTestId}>
                    <div onClick={() => navigate(item.link)}>{item.label}</div>
                  </div>
                </Menu.Item>
              </>
            );
          })}
        </Menu>
      </Sider>
    </>
  );
}

DashboardLayoutSider.propTypes = {
  collapsed: propTypes.bool,
  setCollapsed: propTypes.func,
};

export default DashboardLayoutSider;
